import { render, staticRenderFns } from "./TableFacilidades.vue?vue&type=template&id=b9e62e58&"
import script from "./TableFacilidades.vue?vue&type=script&lang=js&"
export * from "./TableFacilidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports